<router-outlet></router-outlet>
<app-loader *ngIf="contentLoading" class="solid-bg"></app-loader>
